/**
 * Created by Allan on 2022/03/01.
 * Contact 84880528@qq.com.
 * Http请求方法
 */
import Vue from 'vue'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid';
import getQueryString from "@/config/getQueryString";
Vue.prototype.$axios = axios;  //将axios挂载在Vue实例原型上
axios.defaults.baseURL = '/api/';

// 设置axios请求的token
axios.defaults.headers.common['token'] = getQueryString(location.hash, "token");
axios.defaults.headers.common['appId'] = getQueryString(location.hash, "appId");
axios.interceptors.request.use(config=>{
    config.headers['MS-Request-Id']=uuidv4().toUpperCase();
    return config;
})

const successHandler=function(response){
    if(!response.data.success){
        return Promise.reject(response.data);
    }
    if(response.data.code === "401401"){
        QC.goLogin(); //调用原生
    }
    return Promise.resolve(response.data);
};

const errorHandler=function(error){
    console.error("http-error",error);
    if(error.response){
        return Promise.reject({code:error.code,message:'Web page was scraped, please wait...'});
    }
    return Promise.reject(error);
};

const Http=function(url,data){
    return axios.post(url,data).then(successHandler).catch(errorHandler)
};

export default Http






// WEBPACK FOOTER //
// ./src/config/Http.js